//AWS Mobile Project Constants for pine Thu Jul 18 21:04:45 UTC 2024
const awsmobile = {
"aws_cognito_identity_pool_id":"us-east-1:23db0633-9798-4455-8a59-da79bfc48566",
"aws_user_pools_web_client_id":"6jsmh56aebtroodlik0tqd0mnt",
"aws_user_files_s3_bucket":"cb-cds-aiform-data-pine",
"aws_user_pools_id":"us-east-1_CFTwkKzsB",
'aws_cognito_region': 'us-east-1',
'aws_content_delivery': 'enable',
'aws_content_delivery_bucket_region': 'us-east-1',
'aws_content_delivery_cloudfront': 'enable',
'aws_mandatory_sign_in': 'enable',
'aws_project_id': 'f0a08212-a616-4cbf-8e7a-b7b107e3c701',
'aws_project_name': 'cds-mobile',
'aws_project_region': 'us-east-1',
'aws_resource_name_prefix': 'cb-cds-mobile',
'aws_sign_in_enabled': 'enable',
'aws_user_files': 'enable',
'aws_user_files_s3_bucket_region': 'us-east-1',
'aws_user_pools': 'enable',
'aws_user_pools_mfa_type': 'OFF',
'aws_user_settings': 'enable',
'aws_cloud_logic': 'enable',
'aws_cloud_logic_custom':'[{"id":"schoolcode-api-pine","name":"AiFormRequest","paths":["/save"],"endpoint":"https://schoolcode-api.cds-prod.collegeboard.org/pine"}]'
}
export default awsmobile;
